import { DateTime } from "luxon";

import {
  mapScannedCardToPatientValues,
  normalizeDateOfBirthValue,
  normalizeHealthCard,
} from "Utils/Normalization";

export const DEFAULT_INITIAL_VALUES = {
  firstName: "",
  lastName: "",
  dob: null,
  address: "",
  city: "",
  province: "MB",
  postalCode: "",
  healthCardProvince: "MB",
  healthCardNumber: "",
  registrationNumber: "",
  email: "",
  primaryPhone: "",
  secondaryPhone: "",
  preferredLanguage: "",
};

const trimValue = (value) => (value || "").trim();

const parseDob = (dob) => {
  const parsed = DateTime.fromFormat(dob, "yyyy-MM-dd");
  return parsed?.isValid ? parsed : null;
};

export const mapScannedCardToInitialValues = (scannedCard = {}) => {
  const values = mapScannedCardToPatientValues(scannedCard);

  return {
    firstName: values.firstName,
    lastName: values.lastName,
    dob: parseDob(values.dob),
    healthCardNumber: normalizeHealthCard(values.healthCardNumber),
    registrationNumber: values.registrationNumber,
    preferredLanguage: values.preferredLanguage,
  };
};

export const mapSearchValuesToInitialValues = (searchValues = {}) => {
  const dob = normalizeDateOfBirthValue(searchValues?.dateOfBirth);

  return {
    lastName: trimValue(searchValues?.lastName),
    dob: dob?.isValid ? dob : null,
    healthCardNumber: normalizeHealthCard(searchValues?.healthCardNumber),
  };
};

const normalizeGuestPatientValues = (values) => ({
  ...values,
  firstName: trimValue(values.firstName),
  lastName: trimValue(values.lastName),
  dob: values.dob?.toFormat("yyyy-MM-dd") || "",
  address: trimValue(values.address),
  city: trimValue(values.city),
  postalCode: trimValue(values.postalCode).toUpperCase(),
  healthCardNumber: normalizeHealthCard(values.healthCardNumber),
  registrationNumber: trimValue(values.registrationNumber),
  email: trimValue(values.email).toLowerCase(),
  primaryPhone: trimValue(values.primaryPhone),
  secondaryPhone: trimValue(values.secondaryPhone),
  preferredLanguage: trimValue(values.preferredLanguage),
});

export const buildGuestPatientPayload = (values) =>
  Object.fromEntries(
    Object.entries(normalizeGuestPatientValues(values)).filter(
      ([, value]) => value !== "" && value != null
    )
  );
